import { ChangeDetectionStrategy, Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReminderStore } from '../../store/reminders-store';
import { Reminder } from 'src/app/models/reminder';
import { Router } from '@angular/router';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { GlobalStore } from 'src/app/store/global-store';
import { map } from 'rxjs';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { Recipient, Recipients } from 'src/app/models/recipients.model';
import { ContactTooltipComponent } from 'src/app/shared/components/contact-tooltip/contact-tooltip.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { ChooseRecipientsComponent } from 'src/app/features/users/components/choose-recipients/choose-recipients.component';
import { User } from 'src/app/models/user.model';
import { RemindersApiService } from 'src/app/services/reminders-api.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DistributionRecipientsComponent } from 'src/app/features/questionnaires/features/table-grid/features/questionnaires-list-page/components/distribution-recipients/distribution-recipients.component';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { QueDatePipe } from 'src/app/pipes/date.pipe';
import { CreateReminderComponent } from '../create-reminder/create-reminder.component';

@Component({
    selector: 'que-reminders-list-item',
    imports: [CommonModule, MatMenuModule, MatButtonModule, TranslateDirective, TranslatePipe, OverlayModule, QueDatePipe,
        ContactTooltipComponent, DistributionRecipientsComponent],
    templateUrl: './reminders-list-item.component.html',
    styleUrls: ['./reminders-list-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RemindersListItemComponent {
  @Input() isLast = false;
  @Input()
  reminder?: Reminder;
  @Input()
  isByFolders = false;
  
  @ViewChild('trigger') trigger!: ElementRef;

  #router = inject(Router)
  #reminderStore = inject(ReminderStore);
  #reminderApiService = inject(RemindersApiService);
  #dialog = inject(MatDialog);
  #globalStore = inject(GlobalStore);
  frequency$ = inject(GlobalStore).frequency$.pipe(map(x => x.find(f => f.id == this.reminder?.frequencyId)))
  users?: Recipient[] = [];
  isMenuOpen = false;
  readonly positonArea = [{
    originX: 'center',
    originY: 'center',
    overlayX: 'end',
    overlayY: 'top',
  }] as ConnectedPosition[];
  constructor(private sanitizer: DomSanitizer) { }

  getSanitizedHtml(content: string): SafeHtml {
    var x = this.sanitizer.bypassSecurityTrustHtml(content);
    return x;
  }
  ngOnInit(): void {
    // if(this.questionnaire)
    this.users = [
      ...(this.reminder?.recipients?.users ?? []),
      ...(this.reminder?.recipients?.groups?.map(x => x.users?.map(y => y)) ?? []),
    ].flat() as Recipient[];
  }
  edit() {
    this.isMenuOpen=false;
    this.#dialog.open(CreateReminderComponent,
      {
        data: { name: this.#globalStore.isHeSignal$()? "שם התזכורת":"The name of the reminder", isReminder: true, editReminder: this.reminder, recipients: this.reminder?.recipients },
        autoFocus: false,
        position: { top: '6%' },
        panelClass: 'dialog-panel'
      })
      .afterClosed().subscribe((result) => {
        if (result) {
          const [recipients, reminderForm, mailForm, event] = result;
          if ((recipients || mailForm) && event) {
            if (event == 'update') {
              const r = recipients as Recipients; 
              this.#reminderStore.updateReminder(
                {
                  id: this.reminder?.id, recipients: r, subject: mailForm?.subject, content: mailForm?.body,
                  startDate: reminderForm?.startDate, frequencyId: reminderForm?.frequencyId,
                  hour: reminderForm.hour,
                  endDate: reminderForm?.endDate, isApproval: reminderForm?.isApproval,
                } as Reminder)
            }
            // hourId: new FormControl<number>(23),
          }
        }

      })
  }
  delete() {
    this.isMenuOpen=false;
    this.#reminderStore.deleteReminder(this.reminder?.id ?? 0);
  }
  send() {
    this.#reminderApiService.sendReminder(this.reminder?.id ?? 0).subscribe(x =>{})
  }
  reminderClick() {
    this.edit();
  }
  openMenu(event: Event) {
    event.stopPropagation();
    const triggerRect = this.trigger.nativeElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    // Check if the menu would open out of the viewport
    if (triggerRect.bottom + 200 > viewportHeight) { // assuming 200px height for the menu
      this.positonArea[0].overlayY = 'bottom';
    } else {
      this.positonArea[0].overlayY = 'top';
    }
   this.isMenuOpen=true
  }
}
